import {get, post, put, del} from '../../actions/apiMethods';
// import {get, post, put, del} from './apiMethods';

const crud = (slug) => ({
  fetchAll: () => get(`idaq/api/${slug}`),
  fetchById: (id) => get(`idaq/api/${slug}/${id}`),
  create: (json) => post(`idaq/api/${slug}`, json),
  update: (id, json) => put(`idaq/api/${slug}/${id}`, json),
  remove: (id) => del(`idaq/api/${slug}/${id}`),
  removeMultiple: (ids) => post(`idaq/api/${slug}/delete`, { ids }),
});

export const imagetag = {
  ...crud('image_tag'),
  updateImageTags: (json) => post('idaq/api/image_tag_station', json)
};

export const imagesource = {
  ...crud('imagesource'),
  album: crud('album')
};
export const imagesourceDevice = {
  ...crud('imagesource_device'),
  fetchAlbumsByStationID: (station_id) => get(`idaq/api/album/${station_id}`)
};
export const image = {
  fetchStationImages: ({station_id, date_from, date_to, filter_date}) => get(`idaq/api/image?station_id=${station_id}&date_from=${date_from}&date_to=${date_to}&filter_date=${filter_date}`),
  fetchLatestImages: (album) => get(`idaq/api/image_latest?album=${album}&limit=10`),
  fetchAlbumsByStationID: (station_id) => get(`idaq/api/album/${station_id}`),
  searchImage: payload => post('idaq/api/image_search', payload)
};


// WEBPACK FOOTER //
// ./src/components/IDaq/api.js